import IndependantPayment from "./IndependantPayment";
export default IndependantPayment